import React, { useEffect } from "react";
import { Marker } from "react-leaflet";
import L from "leaflet";
import { getDynamicDeviceIcon, getRescAlertStatus } from "utils/iconUtils";
import rescalert_map_pin from "assets/RescAlert_Map_Pin.png";
import { hasClosedDevices } from "utils/statusUtils";

const DeviceMarker = ({
  group,
  category,
  mapZoom,
  calcZoom,
  deviceTypeToCategory,
  auth,
  triggerLoginOpen,
  setMapCenter,
  setMapZoom,
  setCalcZoom,
  popupOpen,
  setPopupOpen,
  listSelect,
  selectedDevices,
  toggleDevice,
  saveSuccess,
  handleSave,
  setLoginPopupOpen,
  collapsedGroups,
  toggleGroupCollapse,
  calculateBounds,
  groupedDevices,
  setMultipleGroupsCollapse,
  setShowMobileDevices = () => {},
  setSelectedGroup = () => {},
  setShouldResetFilter = () => {},
}) => {
  // useEffect(() => {
  //   console.log(
  //     "zoom changed in DeviceMarker",
  //     mapZoom,
  //     calcZoom,
  //     zoomThresholdBasedOnDeviceDistance()
  //   );
  // }, [mapZoom, calcZoom]);
  if (!group || !group.devices || group.devices.length === 0) return null;

  const isMultiDevice = group.devices.length > 1;
  const groupKey = `${category}-${group.id}`;
  const isExploded = !collapsedGroups[groupKey];

  const zoomThresholdBasedOnDeviceDistance = () => {
    return 18; // Default zoom level, can be removed for dynamic logic

    // Calculate the average distance between devices in the group
    if (group.devices.length < 2) return 18; // Default zoom for single device

    const locations = group.devices.map((device) =>
      JSON.parse(device.location)
    );
    let totalDistance = 0;
    let count = 0;

    for (let i = 0; i < locations.length; i++) {
      for (let j = i + 1; j < locations.length; j++) {
        const latLng1 = L.latLng(locations[i]);
        const latLng2 = L.latLng(locations[j]);
        totalDistance += latLng1.distanceTo(latLng2);
        count++;
      }
    }

    const averageDistance = totalDistance / count;
    console.log(
      `Average distance between devices in group`,
      group,
      `: ${averageDistance} meters`
    );
    if (averageDistance > 1000) return 8; // Zoom out for larger distances
    if (averageDistance > 500) return 12; // Moderate zoom
    return 14; // Closer zoom for smaller distances
  };

  // If group is exploded (expanded in sidebar), render individual device markers
  if (
    (isExploded || calcZoom >= zoomThresholdBasedOnDeviceDistance()) &&
    isMultiDevice
  ) {
    return (
      <>
        {group.devices.map((device) => (
          <Marker
            key={`exploded-${device.id}-${device.node_id}`}
            position={JSON.parse(device.location)}
            draggable={false}
            icon={L.divIcon({
              className: "",
              html: `<div class="icon-root" style="--elementCount: 1">
                        <div class="icon-container" style="--elementCount: 1">
                            <img src=${getDynamicDeviceIcon({
                              ...device,
                              data: [
                                {
                                  is_offline: false,
                                  status:
                                    device.status === -1 ? 0 : device.status,
                                },
                              ],
                            })} width=30px height=30px />
                        </div>
                        <div class="icon-text-static" style="background-color: ${
                          (device.status === -1 ? 0 : device.status)
                            ? "black"
                            : "white"
                        };color: ${
                (device.status === -1 ? 0 : device.status) ? "white" : "black"
              }; border: ${
                (device.status === -1 ? 0 : device.status)
                  ? "2px solid red"
                  : "2px solid lime"
              }">${getRescAlertStatus({
                ...device,
                data: [
                  {
                    is_offline: false,
                    status: device.status === -1 ? 0 : device.status,
                  },
                ],
              })}</div>
                    </div>`,
              iconSize: [30, 30],
            })}
            interactive
            eventHandlers={{
              click: (e) => {
                console.log(
                  "Clicked individual device in exploded group",
                  device
                );
            setShowMobileDevices(true);
                // Just center on the device when clicked
                setMapCenter(JSON.parse(device.location));
                setMapZoom(16);
                setCalcZoom(16);
              },
            }}
          />
        ))}
      </>
    );
  }

  // For single-device groups that are exploded, show device icon
  if (
    (isExploded || calcZoom >= zoomThresholdBasedOnDeviceDistance()) &&
    !isMultiDevice
  ) {
    const device = group.devices[0];
    return (
      <>
        <Marker
          key={`single-exploded-${device.id}-${device.node_id}`}
          position={JSON.parse(device.location)}
          draggable={false}
          icon={L.divIcon({
            className: "",
            html: `<div class="icon-root" style="--elementCount: 1">
                      <div class="icon-container" style="--elementCount: 1">
                          <img src=${getDynamicDeviceIcon({
                            ...device,
                            data: [
                              {
                                is_offline: false,
                                status:
                                  device.status === -1 ? 0 : device.status,
                              },
                            ],
                          })} width=30px height=30px />
                      </div>
                      <div class="icon-text-static" style="background-color: ${
                        (device.status === -1 ? 0 : device.status)
                          ? "black"
                          : "white"
                      };color: ${
              (device.status === -1 ? 0 : device.status) ? "white" : "black"
            }; border: ${
              (device.status === -1 ? 0 : device.status)
                ? "2px solid red"
                : "2px solid lime"
            }">${getRescAlertStatus({
              ...device,
              data: [
                {
                  is_offline: false,
                  status: device.status === -1 ? 0 : device.status,
                },
              ],
            })}</div>
                  </div>`,
            iconSize: [30, 30],
          })}
          interactive
          eventHandlers={{
            click: (e) => {
              console.log("Clicked exploded single device", device);
            setShowMobileDevices(true);
              // Just center on the device when clicked
              setMapCenter(JSON.parse(device.location));
              setMapZoom(16);
              setCalcZoom(16);
            },
          }}
        />
      </>
    );
  }

  // Original group marker logic (when collapsed in sidebar)
  return (
    <>
      <Marker
        key={`${category}-${group.id}-${calcZoom}`}
        position={group.center}
        draggable={false}
        icon={L.divIcon({
          className: "",
          html: `<div class="icon-root" style="--elementCount: 1">
                    <div class="icon-container" style="--elementCount: 1;gap: 10px">
                        <img src=${rescalert_map_pin} width=30px height=30px />
                    </div>
                    ${
                      // !isMultiDevice &&

                      hasClosedDevices(group)
                        ? ` <div class="icon-container" style="--elementCount: 1">
                        <div class='icon-warning-static'>${"!"}</div>
                    </div>`
                        : ""
                      //   ` <div class="icon-container" style="--elementCount: 1">
                      //     <div class='icon-number-static'>${group.devices.length}</div>
                      // </div>`
                    }
                   
                </div>`,
          iconSize: [30, 30],
        })}
        interactive
        eventHandlers={{
          click: (e) => {
            console.log("Clicked group marker", group);
            setSelectedGroup(group);
            setShouldResetFilter(false);
            setTimeout(() => {
              setShouldResetFilter(true);
            }, 2500);
            setShowMobileDevices(true);

            // Create new collapsed state with all groups collapsed except this one
            const newCollapsedState = {};

            // First, collapse ALL groups
            Object.keys(groupedDevices).forEach((cat) => {
              groupedDevices[cat].forEach((grp) => {
                const key = `${cat}-${grp.id}`;
                newCollapsedState[key] = true; // Collapse all groups
              });
            });

            // Then expand only the clicked group
            newCollapsedState[groupKey] = false;

            // Apply the new state using setMultipleGroupsCollapse
            setMultipleGroupsCollapse(newCollapsedState);

            // Calculate bounds and zoom to show all devices in the clicked group
            const bounds = calculateBounds(group.devices);
            if (bounds) {
              setMapCenter(bounds.center);
              setMapZoom(bounds.zoom);
              setCalcZoom(bounds.zoom);
            }
          },
        }}
      />
    </>
  );
};

export default DeviceMarker;
